class LocalizationDrawer extends Drawer {}
customElements.define('localization-drawer', LocalizationDrawer);

class LocalizationDrawerButton extends DrawerButton {
  handleClick() {
    let action = (this.dataset.action) ? this.dataset.action : 'open';

    if (action === 'open') {
      this.drawer.open();
    } else {
      this.drawer.close();
    }
  }
}

customElements.define('localization-button', LocalizationDrawerButton);
